"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowViewOptionsButton = exports.shouldShowPermanentOOSButton = exports.shouldShowInStoreOnly = exports.shouldShowEmwbisButton = exports.shouldShowAddToBasketButton = void 0;
var productHasPrice = function productHasPrice(price) {
  return typeof price === 'string' && price !== '' || (price === null || price === void 0 ? void 0 : price.now) != null && Number(price.now) !== 0;
};
var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};
var shouldShowAddToBasketButton = exports.shouldShowAddToBasketButton = function shouldShowAddToBasketButton() {
  var _availability$futureA;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasButton = arguments.length > 1 ? arguments[1] : undefined;
  var outOfStock = product.outOfStock,
    isInStoreOnly = product.isInStoreOnly,
    type = product.type,
    isMadeToMeasure = product.isMadeToMeasure,
    isFabricByLength = product.isFabricByLength,
    price = product.price,
    availability = product.availability,
    _product$customerNoti = product.customerNotifiableEvents,
    _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
    backInStock = _product$customerNoti2.backInStock,
    onRelease = _product$customerNoti2.onRelease,
    onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
    newlyInStock = _product$customerNoti2.newlyInStock;
  var isPreorderBackInStock = backInStock && outOfStock;
  var availableToOrderFromMessage = availability === null || availability === void 0 || (_availability$futureA = availability.futureAvailability) === null || _availability$futureA === void 0 ? void 0 : _availability$futureA.availableToOrderFromMessage;
  var isFutureRelease = isPreorderBackInStock || onRelease || onPreorderLaunch || newlyInStock || availableToOrderFromMessage;
  if (isFutureRelease || outOfStock || isInStoreOnly || type === 'asaf' || isMadeToMeasure || type === 'productSet' || type === 'bundle' || isFabricByLength || !productHasPrice(price) || !hasButton) {
    return false;
  }
  return true;
};
var shouldShowEmwbisButton = exports.shouldShowEmwbisButton = function shouldShowEmwbisButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasButton = arguments.length > 1 ? arguments[1] : undefined;
  var outOfStock = product.outOfStock,
    isInStoreOnly = product.isInStoreOnly,
    _product$customerNoti3 = product.customerNotifiableEvents,
    _product$customerNoti4 = _product$customerNoti3 === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti3,
    backInStock = _product$customerNoti4.backInStock,
    onRelease = _product$customerNoti4.onRelease,
    onPreorderLaunch = _product$customerNoti4.onPreorderLaunch,
    newlyInStock = _product$customerNoti4.newlyInStock;
  var isPreorderBackInStock = backInStock && outOfStock;
  if ((isPreorderBackInStock || onPreorderLaunch || onRelease || newlyInStock) && !isInStoreOnly && hasButton) {
    return true;
  }
  return false;
};
var shouldShowInStoreOnly = exports.shouldShowInStoreOnly = function shouldShowInStoreOnly() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var hasButton = arguments.length > 1 ? arguments[1] : undefined;
  var isInStoreOnly = product.isInStoreOnly;
  if (isInStoreOnly && hasButton) {
    return true;
  }
  return false;
};
var shouldShowPermanentOOSButton = exports.shouldShowPermanentOOSButton = function shouldShowPermanentOOSButton(product, hasButton) {
  var _availability$futureA2, _availability$preOrde;
  var outOfStock = product.outOfStock,
    isInStoreOnly = product.isInStoreOnly,
    availability = product.availability,
    _product$customerNoti5 = product.customerNotifiableEvents,
    _product$customerNoti6 = _product$customerNoti5 === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti5,
    _product$customerNoti7 = _product$customerNoti6.backInStock,
    backInStock = _product$customerNoti7 === void 0 ? false : _product$customerNoti7,
    _product$customerNoti8 = _product$customerNoti6.onRelease,
    onRelease = _product$customerNoti8 === void 0 ? false : _product$customerNoti8,
    _product$customerNoti9 = _product$customerNoti6.onPreorderLaunch,
    onPreorderLaunch = _product$customerNoti9 === void 0 ? false : _product$customerNoti9,
    _product$customerNoti10 = _product$customerNoti6.newlyInStock,
    newlyInStock = _product$customerNoti10 === void 0 ? false : _product$customerNoti10;
  var hasNotifiableEvents = backInStock || onRelease || onPreorderLaunch || newlyInStock;
  var isPreOrderable = (availability === null || availability === void 0 || (_availability$futureA2 = availability.futureAvailability) === null || _availability$futureA2 === void 0 ? void 0 : _availability$futureA2.availableToOrderFromMessage) || (availability === null || availability === void 0 || (_availability$preOrde = availability.preOrder) === null || _availability$preOrde === void 0 ? void 0 : _availability$preOrde.streetDateMessage);
  if (outOfStock && !isPreOrderable && !hasNotifiableEvents && !isInStoreOnly && hasButton) {
    return true;
  }
  return false;
};
var shouldShowViewOptionsButton = exports.shouldShowViewOptionsButton = function shouldShowViewOptionsButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var showViewOptions = arguments.length > 1 ? arguments[1] : undefined;
  var outOfStock = product.outOfStock,
    isMultiSku = product.isMultiSku,
    isMadeToMeasure = product.isMadeToMeasure,
    isFabricByLength = product.isFabricByLength;
  if ((outOfStock || isMultiSku || isMadeToMeasure || isFabricByLength) && showViewOptions) {
    return true;
  }
  return false;
};